<template>
    <ion-page>
        <standard-header title="Packs" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <skeleton :rows="4" v-if="shipments === null"/>
            <sub-title v-if="shipments !== null" :count="shipments?shipments.length:null">My Packs</sub-title>
            <div v-show="shipments && shipments.length < 1">
                <no-results title="No Results">
                    No packs have been assigned to you
                </no-results>
            </div>
            <div v-if="shipments !== null">
                <ion-item>
                    <ion-label>Filter by Drop Off</ion-label>
                    <ion-select v-model="currentZoneId">
                        <ion-select-option :value="null">All</ion-select-option>
                        <ion-select-option :value="zone.id" v-for="zone in zones" :key="zone.id">
                            {{ zone.name }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>
                <ion-list>
                    <div v-for="shipment in filteredShipments" :key="shipment.id">
                        <ion-item detail button @click.stop="goToShipment(shipment)" lines="none">
                            <pick-list-item :shipment="shipment" :completed="shipment.is_packed"/>
                            <shipment-membership-tools
                                type="shipments"
                                stage="pack"
                                name="pack"
                                @updated="refresh()"
                                ref="members"
                                :job="shipment"
                                :users="shipment.packers"
                                v-if="!shipment.packed_at"
                            />
                        </ion-item>
                        <ion-progress-bar :value="shipment.pc_complete/100" />
                    </div>
                </ion-list>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {alertController, IonContent, IonItem, IonList, IonPage, IonProgressBar,
    IonSelect, IonSelectOption, IonLabel} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader.vue";
import SubTitle from "@/components/SubTitle";
import NoResults from "@/components/NoResults";
import EventBus from '@/EventBus';
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import router from '@/router';
import ShipmentMembershipTools from "@/components/ShipmentMembershipTools";
import PrioritySorter from "@/services/PrioritySorter";
import PickListItem from "@/views/modules/picking/components/PickListItem";
import _ from "lodash";

export default {
    inject: ['$http'],
    name: 'MyPacksList',
    components: {
        PickListItem,
        ShipmentMembershipTools,
        PullDownRefresh,
        Skeleton,
        NoResults,
        SubTitle,
        StandardHeader,
        IonContent, IonPage, IonItem, IonList,
        IonProgressBar,
        IonSelect, IonSelectOption, IonLabel
    },
    computed: {
        filteredShipments() {
            if (!this.currentZoneId) {
                return this.shipments;
            }
            return _.filter(this.shipments, shipment => {
                return shipment.picking_drop_off_zone_id === this.currentZoneId;
            });
        }
    },
    data() {
        return {
            currentZoneId: null,
            zones: [],
            shipments: null,
        }
    },
    methods: {
        ionViewDidEnter() {

            EventBus().emitter.emit('loading', true);
            this.$http.get('/api/locations/zones?search=is_bay:1').then(response => {
                this.zones = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                EventBus().emitter.emit('loading', false);
            });

            this.refresh();
        },
        goToShipment(shipment) {

            if (shipment.packed_at) {
                alertController.create({
                    message: 'Shipment has already been packed',
                    buttons: ['Ok']
                }).then(alert => alert.present());
                return;
            }

            if (this.$refs.members.hasAcceptedMembership(shipment.packers)) {
                router.push({name: 'packs.pack', params: {id: shipment.id}});
            } else {
                alertController.create({
                    message: 'You have not yet accepted this job',
                    buttons: ['Ok']
                }).then(alert => alert.present());
            }
        },
        refresh(event = null) {
            EventBus().emitter.emit('loading', true);
            this.$http.get('/api/packs/me/shipments', {
                params: {include: 'packers', all: true}
            }).then(response => {
                this.shipments = PrioritySorter.sortByPriorityThen(response.data.items, 'reference');
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
                EventBus().emitter.emit('loading', false);
            });
        }
    }
}
</script>
